export default __webpack_public_path__ + "static/media/kenken.e2633921.png";